import FileInput from './FileInput';
export default FileInput;

export { FileInput };
export FileUpload from './FileUpload';



// WEBPACK FOOTER //
// ./src/js/FileInputs/index.js